import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=08124c88&lang=pug&"
import script from "./CollectionFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08124c88')) {
      api.createRecord('08124c88', component.options)
    } else {
      api.reload('08124c88', component.options)
    }
    module.hot.accept("./CollectionFilters.vue?vue&type=template&id=08124c88&lang=pug&", function () {
      api.rerender('08124c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionFilters.vue"
export default component.exports